import React, { useContext } from 'react';
import ContextMenuItem, { IContextMenuItemProps } from '../../../components/ContextMenuItem';
import ConnectedFormContext from '../../../components/Context/ConnectedFormContext';
import { checkLinePriceApprovalButton, checkLinePriceApproved } from '../../../utils/LineUtils';
import { AlertType } from '../../../graphql/schema/p4types';
import getClientMutationId from '../../../utils/getClientMutationId';
import { useDispatch } from 'react-redux';
import { useP4ToastController } from '../../system/NotificationsArea';
import { Analytics } from '../../../mixpanel';
import { useTemporarySave } from '../../../components/connectedForm/utils/handleTemporarySave';
import { useCanApproveManualPrices } from '../../salesLedger/tradeCounter/hooks';

const ApprovePriceContextMenuItem = ({ rowIdx }) => {
  const connectedForm = useContext(ConnectedFormContext);
  const dispatch = useDispatch();
  const p4ToastController = useP4ToastController();
  const performTemporarySave = useTemporarySave();
  const selectedOrderLine = connectedForm.values?.orderLines?.[rowIdx];
  const canApprovePrices = useCanApproveManualPrices();

  const onApprovePriceClick: IContextMenuItemProps['onClick'] = (value, close, rowIdx) => {
    const mutationId = getClientMutationId();

    Promise.all([
      dispatch(connectedForm.change(`orderLines.${rowIdx}.priceApproved`, true, mutationId)),
      dispatch(connectedForm.change(`orderLines.${rowIdx}.priceApprovedActionTriggered`, true, mutationId)),
    ]).then(() => {
      performTemporarySave();
      p4ToastController.dispatchSimpleToast(
        'Manual Price Approved',
        `Manual Price on line ${selectedOrderLine.lineOrder} has been approved`,
        AlertType.Info
      );
      Analytics.track('Manual Price Approved', { SelectedOrderLine: selectedOrderLine });
    });
  };

  return (
    <ContextMenuItem
      key={'approvePrice'}
      onClick={onApprovePriceClick}
      label={checkLinePriceApproved(selectedOrderLine) ? 'Unapprove Manual Price' : 'Approve Manual Price'}
      available={checkLinePriceApprovalButton(selectedOrderLine) && canApprovePrices}
      rowIdx={rowIdx}
    />
  );
};

export default ApprovePriceContextMenuItem;
